(ns yardwerkz.web.booking.schedule
  "Step 5: Date and time slot selection."
  (:require
   [uix.core :refer [defui $ use-state use-callback]]
   [io.factorhouse.rfx.core :as rfx]
   [yardwerkz.web.store :as store]
   [yardwerkz.web.ui.components :as ui]
   [yardwerkz.web.ui.icons :as icons]))

(def ^:private time-slots
  [{:id "morning"   :label "Morning"   :desc "8am - 12pm"  :icon icons/Clock}
   {:id "afternoon" :label "Afternoon" :desc "12pm - 4pm"  :icon icons/Clock}
   {:id "evening"   :label "Evening"   :desc "4pm - 7pm"   :icon icons/Clock}])

(defn- min-date
  "Tomorrow's date as yyyy-MM-dd string."
  []
  (let [d (js/Date.)
        _ (.setDate d (inc (.getDate d)))]
    (.toISOString (.toLocaleDateString d "sv-SE"))))

(defui schedule-step [{:keys [on-next on-back]}]
  (let [dispatch (rfx/use-dispatch)
        saved-schedule (rfx/use-sub [::store/draft-schedule])
        [date set-date] (use-state (get saved-schedule :date ""))
        [time-slot set-time] (use-state (get saved-schedule :time nil))

        persist!
        (use-callback
         (fn [d t]
           (dispatch [::store/set-schedule {:date d :time t}]))
         [dispatch])]

    ($ :div {:class "space-y-6"}
       ($ :h2 {:class "text-lg font-semibold text-gray-900"} "When would you like service?")

       ;; Date picker
       ($ :div
          ($ :label {:class "block text-sm font-medium text-gray-700 mb-2"} "Preferred date")
          ($ :input {:type "date"
                     :class "w-full px-4 py-3 border border-gray-300 rounded-xl text-sm focus:outline-none focus:ring-2 focus:ring-green-500 focus:border-green-500"
                     :value date
                     :min (min-date)
                     :on-change (fn [e]
                                  (let [v (.. e -target -value)]
                                    (set-date v)
                                    (persist! v time-slot)))}))

       ;; Time slots
       ($ :div
          ($ :label {:class "block text-sm font-medium text-gray-700 mb-2"} "Preferred time")
          ($ :div {:class "grid grid-cols-3 gap-3"}
             (for [{:keys [id label desc icon]} time-slots]
               (let [selected? (= time-slot id)]
                 ($ :button {:key id
                             :class (str "flex flex-col items-center p-4 rounded-xl border-2 transition-all "
                                         (if selected?
                                           "border-green-500 bg-green-50 shadow-md"
                                           "border-gray-200 hover:border-green-300 hover:bg-gray-50"))
                             :on-click (fn []
                                         (set-time id)
                                         (persist! date id))}
                    ($ icon {:size 24 :class (if selected? "text-green-600" "text-gray-400")})
                    ($ :span {:class "text-sm font-medium mt-2"} label)
                    ($ :span {:class "text-xs text-gray-500"} desc))))))

       ;; Note
       (when (and (seq date) time-slot)
         ($ :div {:class "p-4 bg-green-50 border border-green-200 rounded-xl flex items-start space-x-3"}
            ($ icons/Calendar {:size 20 :class "text-green-600 mt-0.5"})
            ($ :p {:class "text-sm text-green-900"}
               (str "Scheduled for " date
                    " — " (some #(when (= (:id %) time-slot) (:desc %)) time-slots))))))))
